import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "../styles/HiringGuideline.css";  // Add your custom CSS

const HiringGuideline = () => {
    const navigate = useNavigate();
  
    // useEffect(() => {
    //     const existingScript = document.getElementById("razorpay-script");
    
    //     if (!existingScript) {
    //       const script = document.createElement("script");
    //       script.src = "https://checkout.razorpay.com/v1/payment-button.js";
    //       script.async = true;
    //       script.setAttribute("data-payment_button_id", "pl_Q2fwX9qxROgwjc");
    //       script.id = "razorpay-script";  // ✅ Prevent duplicate script
    //       document.getElementById("razorpay-button-container").appendChild(script);
    //     }
    //   }, []);

      // const handlePaymentSuccess = () => {
      //   alert("If you have successfully paid the application fee, you can proceed to the application form. If not you can pay the fee and then proceed otherwise your application form will not be considered.");
      //   navigate("/hiring"); // Redirect to application form
      // };

      const pdfUrl = "/Requirement_26_27.pdf";
  
    return (
      <div className="hiring-container">
        <h1>📢 Teaching & Non-Teaching Staff Recruitment 2025-26</h1>
        <p>Join Shri Kheteshwar Gurukul and be part of a prestigious institution!</p>
  
        <section className="job-details">
          <h2>📌 Available Positions & Requirements</h2>
  
          <ul>
            <li><strong>📚 Teaching Staff:</strong> Sanskrit, English, Science, Mathematics, Hindi, Social Science.</li>
            <li><strong>🎵 Music Teacher:</strong> Degree in Music + 2 years experience.</li>
            <li><strong>⚽ Physical Education Teacher:</strong> B.P.Ed./D.P.Ed. + sports knowledge.</li>
            <li><strong>💻 Computer Teacher:</strong> BCA/MCA with typing skills (Hindi 30-35 wpm, English 40-45 wpm).</li>
            <li><strong>🏠 Hostel Warden:</strong> Discipline & leadership skills required.</li>
            <li><strong>📊 Accountant:</strong> Commerce degree + Computer knowledge.</li>
            <li><strong>🛡 Security Guard:</strong> Retired Army/Defense personnel preferred.</li>
          </ul>
         
            {/* Download Button */}
            <div className="pdf-download">
                <a href={pdfUrl} download className="download-btn">
                Download Application Guide (PDF)
                </a>
            </div>
         
        </section>
  
        <section className="application-process">
          <h2>📝 Application Process</h2>
          <p><strong>Application Dates:</strong> 5th March 2025 – 30th March 2025 (until 12:00 PM).</p>
          <p><strong>Selection:</strong> Written Exam + Interview.</p>
          <p><strong>Written Exam Details:</strong></p>
          <ul>
            <li>📜 General Knowledge (Rajasthan): 5 Questions</li>
            <li>📖 Hindi Language: 3 Questions</li>
            <li>🗣 English Language: 2 Questions</li>
            <li>🧮 Mathematics: 2 Questions</li>
            <li>🧘‍♂️ Yoga & Discipline: 5 Questions</li>
            <li>🧑‍🏫 Subject Knowledge: 30 Questions</li>
            <li>✍️ Written Exam: 55 Marks</li>
            <li>🗣 Interview: 45 Marks</li>
          </ul>
        </section>
  
        <section className="payment-sectionHHH">
        <h2 className="payment-titleHHH">💳 Pay Application Fee</h2>
        <p className="application-feeHHH">Application Fee: <strong>₹100 (INR)</strong></p>

        {/* ✅ Razorpay Payment Button (Only One) */}
        {/* <div id="razorpay-button-container"></div> */}

        {/* <button className="continue-btnHHH" onClick={handlePaymentSuccess}>
            ✅ Payment Done?? Click Here to Proceed to Application Form
        </button> */}
        </section>

  
        {/* <footer className="hiring-footer">
          <p>📞 Contact: 9492821008 | 🌐 <a href="https://www.kheteshwargurukul.edu.in" target="_blank">www.kheteshwargurukul.edu.in</a></p>
        </footer> */}
      </div>
    );
  };
  
  export default HiringGuideline;
